import { requestOptions } from '../helpers/request-options'
import { handleResponse } from '../helpers/handle-response'

export const bidsService = {
  getData,
  getDataById,
  deleteDataById,
  update,
  add,
  uploadFile,
  getFileFile,
  deleteFile
}

function getData ({ q, limit, ordering, offset }) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/bids/?${q}&limit=${limit}&ordering=${ordering}&offset=${offset}`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(bids => {
      return bids
    })
}

function getDataById (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/bids/${id}/?expand=legal_entity,utility_state,terms,created_by,modified_by`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(bids => {
      return bids
    })
}

function deleteDataById (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/bids/${id}/`
  return fetch(url, requestOptions.delete())
    .then(handleResponse)
    .then(bids => {
      return bids
    })
}

function add (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/bids/`
  return fetch(url, requestOptions.post(payload))
    .then(handleResponse)
    .then(bids => {
      return bids
    })
}

function update (payload, id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/bids/${id}/`
  return fetch(url, requestOptions.put(payload))
    .then(handleResponse)
    .then(bids => {
      return bids
    })
}

function uploadFile (payload) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/file/`
  return fetch(url, requestOptions.postFormData(payload))
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function getFileFile (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/file/?limit=9999999&object_id=${id}`
  return fetch(url, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data
    })
}

function deleteFile (id) {
  const url = `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/api/mpg/file/${id}`
  return fetch(url, requestOptions.delete())
    .then(handleResponse)
    .then(data => {
      return data
    })
}



// WEBPACK FOOTER //
// ./src/services/bids.service.js